module.exports = __webpack_public_path__ + "img/resource-tab-open.428168e8.png";